import { boot } from "quasar/wrappers"
import {
  initiateBaseSchemaHashes,
  initiateChangesSchemaHashes,
  initiateCommonSchemaHashes,
} from "src/db/helpers"
import { useAuthStore } from "src/stores/authStore"

/**
 * Initiate schema hashes once in boot
 *
 * Alternatively this could be done in {@link constructImportCollection}, but
 * that would render that function unnecessarily async.
 */
export default boot(async () => {
  const authStore = useAuthStore()

  // No need to build hashes if there is no data
  if (authStore.selectedWorkspace) {
    await initiateBaseSchemaHashes()
    await initiateChangesSchemaHashes()
  }
  await initiateCommonSchemaHashes()
})
